
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","viewBox":"0 0 750 500"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#21428e","d":"M0 0h750v500H0z"}}),_c('path',{attrs:{"d":"M375 0v500M0 250h750","stroke":"#fff","stroke-width":"72.5"}}),_c('path',{attrs:{"id":"a","d":"M62.3 11.9C59.9 13 58 14.6 58 15.4c0 .9 1.4.9-.4 1.5-1.7.6-6.3 1.4-9.5 1.3-1.1 0-3.7-.7-4.4-.7-.8.1 3.4 1.8 1.8 1.4-2.2-.6-3.5-.8-1.8.3 1.3.8 4.2.8 8.3.3 1.6-.2 5.8-1.1 7.3-1.3 1-.1 1 .8 1.6.8 5.4.3 15 .1 19.2-.5 3.5-.5 4.8-.3 5.8.9 2 2.3-.1 4.3-5.8 5.5-7 1.5-9.9 2.8-12.6 5.7-6.5 7 1.1 14.9 15.3 16 8.3.7 13.7 2.3 12.4 3.6-.5.5-6 1.3-12.3 1.8-13.7 1.1-19.8 3-25 8-2.9 2.8-3.9 4.5-3.9 6.8 0 3.2 0 3.2-5.3 3.2-2.8 0-6.7-.4-8.5-1-2.8-.7-3.2-.7-2.2.5 2 2.4 7.7 4.5 12.4 4.5 3.6 0 5.6.7 8.8 3 6.4 4.7 13.7 6.5 25.8 6.4 15.9-.1 25-4.3 25-11.4 0-5.3-6-8.4-18.5-9.5-6.3-.6-18.7.4-24.1 2-1 .3.1-.4 2.5-1.6 2.9-1.4 7.7-2.4 14.2-3 14.4-1.2 20.9-4.4 20.9-10.4 0-5.8-6.4-9.1-20.1-10.4-13.5-1.2-14.5-3.6-3.1-7.1C89.9 29.6 94 26 94 21.1c0-7.5-4.1-10-17.8-10.7-8.3-.4-10.3-.2-13.9 1.5zm7.2 2.1c-.3.5-1.1 1-1.6 1-.6 0-.7-.5-.4-1 .3-.6 1.1-1 1.6-1 .6 0 .7.4.4 1zm28.9 56c1.9.7 2.6 1.4 2 2-1.7 1.7-12.7 3.2-19.4 2.7-7.4-.7-15.4-3.1-13-4.1 6.7-2.6 24.3-2.9 30.4-.6z","transform":"scale(2.3)","fill":"#fff"}}),_c('use',{attrs:{"xlink:href":"#a","x":"411.25"}}),_c('use',{attrs:{"xlink:href":"#a","y":"286.25"}}),_c('use',{attrs:{"xlink:href":"#a","x":"411.25","y":"286.25"}})])
          )
        }
      }
    